import React from 'react';
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface VersionToggleProps {
  showCurrentOnly: boolean;
  onToggleChange: (checked: boolean) => void;
  slug?: string | null;
  subslug?: string | null;
  actualVersion?: string | null;
  getMostRecentVersionWithPlans?: () => string | null;
}

const VersionToggle: React.FC<VersionToggleProps> = ({
  showCurrentOnly,
  onToggleChange,
  slug,
  subslug,
  actualVersion,
  getMostRecentVersionWithPlans
}) => {
  // Format a quarterly version string to a readable format
  const formatVersionDisplay = (version: string | null): string => {
    if (!version) return '';
    
    // Extract the quarterly part (last segment after '/')
    const quarterlyPart = version.split('/').pop() || '';
    
    // If it starts with something like "2023Q2"
    if (/^\d{4}Q[1-4]/.test(quarterlyPart)) {
      const year = quarterlyPart.substring(0, 4);
      const quarter = quarterlyPart.substring(5, 6);
      
      // Map quarter number to months
      const quarterToMonth: Record<string, string> = {
        '1': 'Jan-Mar',
        '2': 'Apr-Jun',
        '3': 'Jul-Sep',
        '4': 'Oct-Dec'
      };
      
      return `${quarterToMonth[quarter]} ${year}`;
    }
    
    // Handle YYYYMMDD format (e.g., 20250521)
    if (/^\d{8}$/.test(quarterlyPart)) {
      const year = quarterlyPart.substring(0, 4);
      const month = quarterlyPart.substring(4, 6);
      const day = quarterlyPart.substring(6, 8);
      
      // Convert month number to name
      const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      const monthIndex = parseInt(month, 10) - 1;
      const monthName = monthNames[monthIndex];
      
      return `${monthName} ${parseInt(day, 10)}, ${year}`;
    }
    
    return quarterlyPart;
  };
  return (
    <div className="flex items-center space-x-2">
      <Switch
        id="show-current-versions"
        checked={showCurrentOnly}
        onCheckedChange={onToggleChange}
      />
      <Label htmlFor="show-current-versions" className="text-sm">
        {showCurrentOnly 
          ? `Show Current Plans Only ${actualVersion ? `(${formatVersionDisplay(actualVersion)})` : 
              // If getMostRecentVersionWithPlans is provided and returns a version, use that
              (getMostRecentVersionWithPlans && getMostRecentVersionWithPlans()) ? 
                `(${formatVersionDisplay(getMostRecentVersionWithPlans())})` : 
                ''}` 
          : 'Show All Plans'}
      </Label>
    </div>
  );
};

export default VersionToggle;
